// extracted by mini-css-extract-plugin
export default {"header":"CategoryManagement_header__8V2yG","label":"CategoryManagement_label__n+JMr","list":"CategoryManagement_list__zikAc","add":"CategoryManagement_add__c8h4E"};